module.exports = __webpack_public_path__ + "ui-static/img/logo.2ed70831.svg";